import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AreaForm from "../../../../screens/places/components/AreaForm";

export default function RegionsEdit(props) {
  const { t } = useTranslation();
  let { id } = useParams();
  return (
    <AreaForm
      resourceUrl={`/regions/${id}`}
      resourceKey="Regions"
      breadcrumbs={[{ content: t("regions.breadcrumbs.regions"), url: "/places/regions" }]}
    />
  );
}
